import React, { useEffect, useState } from "react";
import { template1, template2, template3 } from "assets/images";
import { FaArrowRight } from "react-icons/fa";
import { Link, useSearchParams } from "react-router-dom";
import { createIcon } from "assets/icons";
import { handleEncryptionParams } from "utils/dataCipherHelper";
import CustomModal from "components/modals/CustomModal";
import { FaArrowRightLong } from "react-icons/fa6";
import SurveyTemplateList from "./SurveyTemplateList";
import { toastMessage } from "utils/toastMessageHelper";
import { getTemplateListAPI } from "services/survey";
import { getFromLocal } from "config/axiosInstance";
import { useTranslation } from "react-i18next";

// Reusable TemplateCard Component
const TemplateCard = ({
  imageSrc,
  title,
  description,
  buttonText,
  nextStep,
}) => {
  return (
    <div className="item">
      <div className="template_card">
        <div className="image_wrap">
          <img src={imageSrc} className="card_img" alt={title} />
        </div>
        <div className="content">
          <h3>{title}</h3>
          <p>{description}</p>
          <div className="button" onClick={nextStep}>
            {buttonText} <FaArrowRight />
          </div>
        </div>
      </div>
    </div>
  );
};

const SurveyTemplates = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [templateModal, setTemplateModal] = useState(false);
  const [templateListData, setTemplateListData] = useState([]);
  const { t } = useTranslation();

  const stepperValueHandler = (value) => {
    const paramsData = { stepper: value };

    const updatedSearchParams = handleEncryptionParams(
      paramsData,
      searchParams
    );
    setSearchParams(updatedSearchParams);
  };

  // Function for get template list
  const getTemplateListHandler = async () => {
    try {
      const sendData = {
        token: getFromLocal(),
      };
      const response = await getTemplateListAPI(sendData);
      const { message = "", status, data } = response;
      if (status === 200) {
        setTemplateListData(data?.surveyTemplateList);
      } else {
        toastMessage(message, "error", "get-template-list");
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getTemplateListHandler();

    // eslint-disable-next-line
  }, []);

  return (
    <>
      <h3 className="dashboard_title">
        {/* What type of test do you want to run today? */}
      </h3>
      <div className="template_wrap">
        <TemplateCard
          buttonText={t("CREATE_SURVEY.start")}
          imageSrc={template1}
          title={t("CREATE_SURVEY.createFromBeginning")}
          description={t("CREATE_SURVEY.createFromBeginningDescription")}
          nextStep={() => stepperValueHandler(2)}
          // setStepper={setStepper}
        />
        <TemplateCard
          buttonText={t("CREATE_SURVEY.start")}
          imageSrc={template2}
          nextStep={() => setTemplateModal(true)}
          title={t("CREATE_SURVEY.selectSurveyTemplate")}
          description={t("CREATE_SURVEY.selectSurveyTemplateDescription")}
          // setStepper={setStepper}
        />
        <TemplateCard
          buttonText={t("CREATE_SURVEY.start")}
          imageSrc={template3}
          title={t("CREATE_SURVEY.createSurveyWithAI")}
          description={t("CREATE_SURVEY.createSurveyWithAIDescription")}
          // nextStep={() => stepperValueHandler(2)}
          nextStep={() => {}}
          // setStepper={setStepper}
        />

        {/* <div className="item">
          <div className="template_card new_survey">
            <button type="button" className="redirect"></button>
            <div className="image_wrap">
              <img src={createIcon} alt="" />
            </div>
            <div className="content">
              <h3>Upload Your Survey Questions</h3>
              <p>
                Quickly add pre-prepared questions to a survey by uploading a
                file. import questions in bulk rather than manually inputting
                them one by one
              </p>
              <div>
                View Sample Slider Download <FaArrowRight />
              </div>
            </div>
          </div>
        </div> */}
      </div>

      <CustomModal
        show={templateModal}
        className={"xl template_card_modal"}
        handleClose={() => setTemplateModal(false)}
      >
        <SurveyTemplateList templateList={templateListData} />
      </CustomModal>
    </>
  );
};

export default SurveyTemplates;
